import { Navigate } from "react-router-dom";
import { APP_ROUTES, AUTH_ROUTES, ROUTE_NAMES } from "../../routes";
import useAuthStore from "../../store/Auth";
import { USER_ROLES_IDS } from "../../constants/common";
import { RolePrivilege } from "../../store/Auth/interface";
import Loader from "../../components/loader";
import { jwtDecode } from "jwt-decode";
import { DecodedUser } from "../../hooks/user/interface";

interface ProtectedRouteProps {
  children: any;
  routeName?: ROUTE_NAMES;
}

const ProtectedRoute = ({ children, routeName }: ProtectedRouteProps) => {
  const { isLoggedIn, userRoles, token } = useAuthStore();

  if (token) {
    const decodedUser: DecodedUser = jwtDecode(token);

    if (
      Number(decodedUser?.RoleId) === USER_ROLES_IDS.ADMIN &&
      routeName === ROUTE_NAMES.INTERNAL_CONFIG
    ) {
      return children;
    }

    if (!isLoggedIn) {
      return <Navigate to={AUTH_ROUTES.LOGIN} replace />;
    }

    if (Object.keys(userRoles).length === 0) {
      return (
        <div className="flex items-center justify-center w-screen pt-[10vh]">
          <Loader />
        </div>
      );
    }

    const hasPrivilege = userRoles?.rolePrivileges?.some(
      (privilege: RolePrivilege) => privilege.s_RouteName === routeName
    );

    const isHomePrivilege = userRoles?.rolePrivileges?.some(
      (privilege: RolePrivilege) =>
        privilege.s_RouteName === ROUTE_NAMES.HOME_SEARCH
    );

    const isApproveVisitRequestsPrivilege = userRoles?.rolePrivileges?.some(
      (privilege: RolePrivilege) =>
        privilege.s_RouteName === ROUTE_NAMES.APPROVE_VISIT_REQUEST_SEARCH
    );

    const isApprovePermitRequestsPrivilege = userRoles?.rolePrivileges?.some(
      (privilege: RolePrivilege) =>
        privilege.s_RouteName === ROUTE_NAMES.APPROVE_PERMIT_REQUEST_SEARCH
    );

    if (!hasPrivilege) {
      return (
        <Navigate
          to={
            Number(decodedUser?.RoleId) === USER_ROLES_IDS.ADMIN ||
              Number(decodedUser?.RoleId) === USER_ROLES_IDS.SECURITY ||
              Number(decodedUser?.RoleId) === USER_ROLES_IDS.SECURITY_MANAGER ||
              Number(decodedUser?.RoleId) === USER_ROLES_IDS.RECEPTION
              ? isHomePrivilege
                ? APP_ROUTES.HOME
                : APP_ROUTES.UNAUTHORIZED
              : isApproveVisitRequestsPrivilege
                ? APP_ROUTES.APPROVE_VISIT_REQUEST
                : isApprovePermitRequestsPrivilege
                  ? APP_ROUTES.APPROVE_PERMIT_REQUEST
                  : APP_ROUTES.UNAUTHORIZED
          }
        />
      );
    }

    return children;
  }

  return <Navigate to={AUTH_ROUTES.LOGIN} replace />;
};

export default ProtectedRoute;
